export const log = (msg: string): void => {
  console.log(`[gologin dbg] ${msg}`);
};
